import { render, staticRenderFns } from "./SportBetHistoryList.vue?vue&type=template&id=0945a57c&scoped=true"
import script from "./SportBetHistoryList.vue?vue&type=script&lang=js"
export * from "./SportBetHistoryList.vue?vue&type=script&lang=js"
import style0 from "./SportBetHistoryList.vue?vue&type=style&index=0&id=0945a57c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0945a57c",
  null
  
)

export default component.exports